import axiosPrivateMl from "@services/axiosPrivateMl"

export const getFacebookConnectionStatus = async (userId) => {
  return await axiosPrivateMl.post(`/facebook_verify_connection`, {
    user_id: userId,
  })
}
